import React, { useState } from 'react'
import { useGetAllCards } from '../../../../../core/services/react-query/report/cards'
import FilterLayout from '../../../../layout/filter/FilterLayout'
import { allCardsOptions, CacheKeys } from '../../../../../core/constants/filter'
import { TABLET_SIZE } from '../../../../../core/constants/common'
import { useWindowSize } from '../../../../../core/hooks/common/useWindowSize'
import CardsTable from './CardsTable'
import RCardsTable from './RCardsTable'

const AllCards = ({ userId }) => {
    const { width } = useWindowSize();
    const [cards, setCards] = useState({ loading: true, data: null })
    const onQuerySuccess = (res) => {
        setCards(res)
    }

    const Component = width > TABLET_SIZE ? CardsTable : RCardsTable

    return (
        <FilterLayout
            query={useGetAllCards}
            options={allCardsOptions}
            onQuerySuccess={onQuerySuccess}
            cache={CacheKeys.All_CARDS}
            extra={{ userId: userId }}
        >
            <Component
                data={cards}
                userId={userId}
            />
        </FilterLayout>
    )
}

export default AllCards